import { render, staticRenderFns } from "./institutionalWallet.vue?vue&type=template&id=28e4c148&scoped=true"
import script from "./institutionalWallet.vue?vue&type=script&lang=js"
export * from "./institutionalWallet.vue?vue&type=script&lang=js"
import style0 from "./institutionalWallet.vue?vue&type=style&index=0&id=28e4c148&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e4c148",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e4c148')) {
      api.createRecord('28e4c148', component.options)
    } else {
      api.reload('28e4c148', component.options)
    }
    module.hot.accept("./institutionalWallet.vue?vue&type=template&id=28e4c148&scoped=true", function () {
      api.rerender('28e4c148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/institutionalWallet.vue"
export default component.exports